import React from 'react';
interface Props {
  fillColor?: string;
}
function VaccinationsIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none">
      <g clipPath="url(#clip0_851_3506)">
        <path
          d="M12.7184 0.470312C12.4246 0.764062 12.4246 1.23906 12.7184 1.52969L13.1871 1.99844L11.9996 3.19219L10.2809 1.47031C9.98711 1.17656 9.51211 1.17656 9.22148 1.47031C8.93086 1.76406 8.92773 2.23906 9.22148 2.52969L11.4715 4.77969L13.7215 7.02969C14.0152 7.32344 14.4902 7.32344 14.7809 7.02969C15.0715 6.73594 15.0746 6.26094 14.7809 5.97031L13.0621 4.25156L14.2496 3.06094L14.7184 3.52969C15.0121 3.82344 15.4871 3.82344 15.7777 3.52969C16.0684 3.23594 16.0715 2.76094 15.7777 2.47031L14.7809 1.47031L13.7809 0.470312C13.4871 0.176563 13.0121 0.176563 12.7215 0.470312H12.7184ZM8.48086 3.20781L2.51211 9.17656C2.18398 9.50781 1.99961 9.95156 1.99961 10.4172V13.1922L0.218359 14.9703C-0.0753906 15.2641 -0.0753906 15.7391 0.218359 16.0297C0.512109 16.3203 0.987109 16.3234 1.27773 16.0297L3.05898 14.2484H5.83398C6.29961 14.2484 6.74336 14.0641 7.07148 13.7359L13.0402 7.76719C13.0309 7.75781 13.0184 7.74844 13.009 7.73594L11.9777 6.70469L6.00898 12.6734C5.96211 12.7203 5.89961 12.7453 5.83086 12.7453L3.49961 12.7516V10.4172C3.49961 10.3516 3.52461 10.2859 3.57148 10.2391L4.42461 9.38594L5.14336 10.1047C5.33711 10.2984 5.65586 10.2984 5.84961 10.1047C6.04336 9.91094 6.04336 9.59219 5.84961 9.39844L5.13086 8.67969L6.42461 7.38594L7.14336 8.10469C7.33711 8.29844 7.65586 8.29844 7.84961 8.10469C8.04336 7.91094 8.04336 7.59219 7.84961 7.39844L7.13086 6.67969L8.42461 5.38594L9.14336 6.10469C9.33711 6.29844 9.65586 6.29844 9.84961 6.10469C10.0434 5.91094 10.0434 5.59219 9.84961 5.39844L9.13086 4.67969L9.54023 4.27031L8.50898 3.23906C8.49961 3.22969 8.49023 3.21719 8.47773 3.20781H8.48086Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3506">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default VaccinationsIcon;
